import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfoService } from '../core/auth/user-info/user-info.service';
import { getFullUrl } from '../shared/utils/url';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  private _loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userInfoService: UserInfoService,
  ) { }

  public async loginWithGluu() {
    this._loading = true;
    const { path, redirect } = this.route.snapshot.data;
    this.userInfoService.refreshUserInfo().subscribe({
      next: userInfo => {
        if (userInfo) {
          this.router.navigate(['/protected/dashboard']).catch(console.error);
        } else {
          window.location.href = getFullUrl(environment.guiBackendRootEndpoint, `${path}?after-redirect=${redirect}&acr_values=basic_rp`);
        }
      },
      error: () => this._loading = false
    });
  }

  public get loading(): boolean {
    return this._loading;
  }
}
